import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet, faFilePen, faGem } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

export default function DashboardHeader() {
  const userServices = useSelector((state) => state.serviceStore.value);
  const navigate = useNavigate();
  const profile = useSelector((state) => state.profileStore.value);
  const isConnected = Boolean(userServices?.isconnected === 1);
  const whatsappStatus = isConnected ? 'Connected' : 'Pending';
  const qualityRating = profile?.quality_rating;
  const messageRating = profile?.message_rating;
  const messagingLimit = profile?.messaging_limit;

  const handleApplyNow = () => {
    const applyCard = document.querySelector('.dashboard-card');
    if (applyCard) {
      applyCard.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Handle Explore Plans button click
  const handleExplorePlans = () => {
    navigate('/client-area/whatsapp/subscription');
  };

  // Get status badge styling
  const getStatusBadgeStyle = (status) => {
    if (status === 'Connected') {
      return {
        color: '#275c53',
        fontWeight: 700,
        background: '#e8f5e8',
        borderRadius: 5,
        padding: '2px 8px',
        fontSize: 11,
      };
    } else {
      return {
        color: '#e53935',
        fontWeight: 700,
        background: '#fdeaea',
        borderRadius: 5,
        padding: '2px 8px',
        fontSize: 11,
      };
    }
  };

  // Get quality rating display info
  const getQualityRatingInfo = (rating) => {
    const normalizedRating = rating ? rating.toUpperCase() : '';
    switch (normalizedRating) {
      case 'GREEN':
        return { color: '#22c55e', label: 'High', bulletColor: '#22c55e' };
      case 'YELLOW':
        return { color: '#f59e0b', label: 'Medium', bulletColor: '#f59e0b' };
      case 'RED':
        return { color: '#ef4444', label: 'Low', bulletColor: '#ef4444' };
      default:
        return { color: '#6b7280', label: 'Unknown', bulletColor: '#6b7280' };
    }
  };

  const qualityInfo = getQualityRatingInfo(qualityRating);

  return (
    <div className="dashboard-header-modern card border-0 shadow-sm" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'center',
      padding: '16px 20px',
      background: '#fff',
      borderRadius: '16px',
      border: '1px solid #e2e8f0',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
      marginBottom: 18,
      gap: 12,
    }}>
      {/* Top Row: Title, Wallet */}
      <div className="dashboard-header-row1" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: 10,
      }}>
        <div style={{ fontSize: 17, fontWeight: 700, color: '#12253f', letterSpacing: -0.2 }}>
          Campaigning Tool
        </div>
        <button
          style={{
            background: '#fff',
            color: '#275c53',
            borderRadius: 999,
            padding: '5px 14px 5px 12px',
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            boxShadow: '0 1px 4px rgba(39,92,83,0.10)',
            border: '1.5px solid #275c53',
            outline: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: 7,
          }}
          title="View Wallet History"
          onClick={() => navigate('/client-area/whatsapp/wallet-history')}
        >
          <FontAwesomeIcon icon={faWallet} style={{ fontSize: 13, color: '#275c53' }} />
          <span style={{ fontWeight: 700, letterSpacing: 0.2, color: '#275c53', fontSize: 13 }}>
            ₹{userServices?.wallet_balance || 0.00}
          </span>
        </button>
      </div>

      {/* Second Row: Status, Plan, Actions */}
      <div className="dashboard-header-row2" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: 12,
        flexWrap: 'wrap',
      }}>
        <div className="dashboard-header-badges" style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <div style={{ color: '#64748b', fontSize: 12.5, display: 'flex', alignItems: 'center', gap: 5 }}>
            <span>WhatsApp Business API Status:</span>
            <span style={getStatusBadgeStyle(whatsappStatus)}>
              {whatsappStatus || "PENDING"}
            </span>
          </div>

          {/* Quality Rating */}
          {whatsappStatus === 'Connected' && qualityRating && (
            <div style={{ color: '#64748b', fontSize: 12.5, display: 'flex', alignItems: 'center', gap: 5 }}>
              <span>Quality Rating:</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <div style={{
                  width: 7,
                  height: 7,
                  borderRadius: '50%',
                  backgroundColor: qualityInfo.bulletColor
                }}></div>
                <span style={{
                  color: qualityInfo.color,
                  fontWeight: 700,
                  background: `${qualityInfo.color}15`,
                  borderRadius: 5,
                  padding: '2px 8px',
                  fontSize: 11,
                }}>
                  {qualityInfo.label}
                </span>
              </div>
            </div>
          )}

          {/* Message Rating */}
          {whatsappStatus === 'Connected' && messageRating && (
            <div style={{ color: '#64748b', fontSize: 12.5, display: 'flex', alignItems: 'center', gap: 5 }}>
              <span>Message Rating:</span>
              <span style={{
                color: '#275c53',
                fontWeight: 700,
                background: '#e8f5e8',
                borderRadius: 5,
                padding: '2px 8px',
                fontSize: 11,
              }}>
                {messageRating}
              </span>
            </div>
          )}

          {/* Messaging Limit */}
          {whatsappStatus === 'Connected' && messagingLimit && (
            <div style={{ color: '#64748b', fontSize: 12.5, display: 'flex', alignItems: 'center', gap: 5 }}>
              <span>Messaging Limit:</span>
              <span style={{
                color: '#2962ff',
                fontWeight: 700,
                background: '#e3f2fd',
                borderRadius: 5,
                padding: '2px 8px',
                fontSize: 11,
              }}>
                {messagingLimit}
              </span>
            </div>
          )}

          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{
              background: '#2962ff',
              color: '#fff',
              borderRadius: 4,
              padding: '2px 7px',
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: 0.1,
            }}>Current</span>
            <span style={{ fontSize: 12.5, color: '#64748b' }}>Plan:</span>
            <span style={{ fontWeight: 700, fontSize: 12.5, color: '#2962ff' }}>
              {userServices.subscription_name ? userServices.subscription_name : 'N/A'}
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="dashboard-header-actions" style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <button
            onClick={handleApplyNow}
            style={{
              background: '#fff',
              color: '#275c53',
              border: '1.5px solid #275c53',
              borderRadius: 7,
              padding: '5px 13px',
              fontWeight: 600,
              fontSize: 13,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              cursor: 'pointer',
              boxShadow: '0 1px 3px rgba(39,92,83,0.08)',
              transition: 'all 0.2s',
            }}
          >
            <FontAwesomeIcon icon={faFilePen} style={{ fontSize: 12, color: '#275c53' }} /> Apply Now
          </button>

          <button
            onClick={handleExplorePlans}
            style={{
              background: '#fff',
              color: '#2962ff',
              border: '1.5px solid #2962ff',
              borderRadius: 7,
              padding: '5px 13px',
              fontWeight: 600,
              fontSize: 13,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              cursor: 'pointer',
              boxShadow: '0 1px 3px rgba(41,98,255,0.08)',
              transition: 'all 0.2s',
            }}
          >
            <FontAwesomeIcon icon={faGem} style={{ fontSize: 12, color: '#2962ff' }} /> Explore Plans
          </button>
        </div>
      </div>

      {/* Responsive styles */}
      <style>{`
        @media (max-width: 768px) {
          .dashboard-header-modern {
            padding: 14px 14px !important;
            border-radius: 14px !important;
            margin-bottom: 14px !important;
          }
          .dashboard-header-row2 {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 10px !important;
          }
          .dashboard-header-badges {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 6px !important;
            width: 100% !important;
          }
          .dashboard-header-actions {
            width: 100% !important;
            display: flex !important;
            gap: 8px !important;
            margin-top: 4px !important;
          }
          .dashboard-header-actions button {
            flex: 1 !important;
            justify-content: center !important;
            padding: 8px 10px !important;
            font-size: 12.5px !important;
          }
        }
      `}</style>
    </div>
  );
} 